import { Component, Injectable, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DeckingBoardsService } from '../../../../services/configurators-2d/applications/decking-boards.service';
import { IBaseComponent } from '../../configurator/i-base-component';
import { DeckingBoardsLocation } from 'src/app/models/configurators-2d/applications/decking-boards/decking-boards-location';
import { Pedestal } from 'src/app/models/configurators-2d/applications/decking-boards/pedestal';
import { DeckingBoardsConfiguratorItem } from '../../configurator/applications/decking-boards-configurator-item';
import { TypeLocationEnum } from 'src/app/enum/decking-boards/type-location.enum';
import { Configurators2DComponent } from '../../configurators-2d.component';
import { DeckingBoardsPreviewComponent } from '../preview/preview.component';
import { PedestalTypeEnum } from '../../../../enum/decking-boards/pedestal-type.enum';

@Component({
  selector: 'ng-decking-boards-environment',
  templateUrl: './environment.component.html',
})
@Injectable({ providedIn: 'root' })
export class DeckingBoardsEnvironmentComponent extends DeckingBoardsConfiguratorItem implements OnInit, IBaseComponent {
  locations: DeckingBoardsLocation[];
  pedestals: Pedestal[];

  currentLang: string;
  isPedestalsAvailable: boolean;

  /* Heights */
  pedestalHeights: any[];
  isAvailable: boolean;
  availableHeightString: String;
  raisedHeight: number;

  //URL de base des images
  baseImgURL: string = undefined;

  preview: DeckingBoardsPreviewComponent;

  constructor(
    private translate: TranslateService,
    deckingBoardsService: DeckingBoardsService,
    configurators2DComponent: Configurators2DComponent
  ) {
    super(deckingBoardsService);
    this.baseImgURL = this.service.apiUrl;
    this.currentLang = this.translate.getBrowserLang();
    this.preview = configurators2DComponent.preview as DeckingBoardsPreviewComponent;
  }

  ngOnInit(): void {
    Promise.all([
      this.service.getPedestals().then(pedestals => (this.pedestals = pedestals)),
      this.service.getLocations<DeckingBoardsLocation>().then(locations => {
        this.locations = [...locations].sort((a, b) => a.displayOrder - b.displayOrder);

        if (this.configuration?.location?.id == null && this.locations) {
          this.selectLocation(this.locations.find(_ => _));
        } else if (this.configuration.location.id) {
          this.selectLocation(this.locations.find(x => x.id == this.configuration.location.id));
          this.raisedHeight = this.configuration.raisedHeight * 10;
        }
      }),
    ]).then(() => {
      this.isAvailable = true;
      this.preview.update();
    });
  }

  /**
   * Fonction de sélection de la location
   * @param location emplacement à sélectionner
   */
  async selectLocation(location: DeckingBoardsLocation): Promise<void> {
    this.configuration.location = location;

    if (this.configuration.location.locationType === TypeLocationEnum.concrete) {
      this.raisedHeight = null;
      this.configuration.raisedHeight = null;
    }

    this.getAvailableHeights();

    let infoShow = document.getElementById('location-info-' + location.id);
    let infos = document.getElementsByClassName('location-info');

    for (let i = 0; i < infos.length; i++) {
      let info = infos[i];

      if (info !== undefined && infoShow != undefined && info.id !== infoShow.id) {
        info.classList.add('d-none');
      }
    }

    if (infoShow !== null) {
      infoShow.classList.remove('d-none');
    }

    await this.preview.update();
  }

  /**
   * Fonction de détermination si la location est sélectionné ou non
   * @param id id de la location
   * @returns boolean
   */
  isLocationSelected(id: number) {
    return this.configuration.location?.id === id;
  }

  displayRaisedHeight(): boolean {
    return (
      this.configuration.location != null && this.configuration.location.locationType !== TypeLocationEnum.concrete
    );
  }

  isNextButtonActive(): boolean {
    return (
      this.configuration.location != null &&
      (this.configuration.location.locationType === TypeLocationEnum.concrete ||
        this.configuration.raisedHeight != null)
    );
  }

  checkPageChangeCapability(): boolean {
    return this.configuration.location !== null;
  }

  isPedestalHeightAvailable() {
    this.isAvailable = false;
    this.getAvailableHeights();
    this.pedestalHeights?.forEach(heights => {
      if (this.raisedHeight >= heights.minHeight && this.raisedHeight <= heights.maxHeight) {
        this.isAvailable = true;
      }
    });
    // Conversion mm to cm
    this.configuration.raisedHeight = this.isAvailable ? this.raisedHeight / 10 : null;
    return this.isAvailable;
  }

  getAvailableHeights() {
    // Conversion cm en mm
    this.pedestalHeights = [];
    this.availableHeightString = this.translate.instant('decking-boards.environment.height-error');
    this.pedestals?.forEach(pedestal => {
      if (
        this.pedestalHeights.findIndex(
          x => x.maxHeight == pedestal.maxHeight * 10 && x.minHeight == pedestal.minHeight * 10
        ) < 0
      ) {
        this.pedestalHeights.push({
          minHeight: pedestal.minHeight * 10,
          maxHeight: pedestal.maxHeight * 10,
          type: pedestal.pedestalType,
        });
      }
    });

    if (this.pedestalHeights?.length > 0) {
      let plasticPiedestals = this.pedestalHeights.filter(ph => ph.type == PedestalTypeEnum.Plastic.valueOf());
      let concretePiedestals = this.pedestalHeights.filter(ph => ph.type == PedestalTypeEnum.Concrete.valueOf());

      this.availableHeightString += `<br>- Plot plastique : de ${Math.min.apply(
        null,
        plasticPiedestals.map(ph => ph.minHeight as number)
      )}mm à ${Math.max.apply(
        null,
        plasticPiedestals.map(ph => ph.maxHeight as number)
      )}mm`;
      this.availableHeightString += `<br>- Plot béton : ${concretePiedestals[0].maxHeight}mm ou ${concretePiedestals[concretePiedestals.length - 1].maxHeight}mm`;
    }
  }
}
